import React from "react";
import RoutinesView from "../components/RoutinesView";

export default function RoutinesMen() {
  return <RoutinesView sex="hombre" title="Rutinas para hombres" />;
}
